<template>
  <v-row   class="layout-invoice">
    <v-col cols="12">
      <gg-card :text="text">
        <gg-card-text>
          <gg-card-header>
            Transactional History
          </gg-card-header>
          <v-data-table :headers="transaction_headers"
                        :items="payments"
                        :items-per-page="itemsPerPage"
                        hide-default-footer>
            <template v-slot:item.net="{ item }">
              {{ moneyFormat(item.net) }}
            </template>
          </v-data-table>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { moneyFormat } from '@/helpers/helpers'

export default {
  name: 'InvoiceHistory',
  props: {
    payments: {
      type: Array,
      required: true
    },
    text: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    transaction_headers: [
      { text: 'Transaction Date', value: 'date', sortable: false },
      { text: 'Transaction ID', value: 'transaction', sortable: false },
      { text: 'Description', value: 'note', sortable: false },
      { text: 'Gateway', value: 'source', sortable: false },
      { text: 'Amount', value: 'net', sortable: false }
    ]
  }),
  computed: mapGetters(['itemsPerPage']),
  methods: {
    moneyFormat
  }
}
</script>

<style scoped>
  .layout {
    background-color: white;
  }
</style>
